import script from "./Vesting.vue?vue&type=script&setup=true&lang=js"
export * from "./Vesting.vue?vue&type=script&setup=true&lang=js"

import "./Vesting.vue?vue&type=style&index=0&id=67d41f38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67d41f38"]])

export default __exports__